import RestfulProvider from "../globals/RestfulProvider";

const headers = {
  Accept: "application/json",
  "Content-type": "application/json",
  isAuthenticated: true,
};
const subUrllocal = "/api/v1/historicalContractSetting";
const localurl = "/api/v1";

class legacyServices {
  getLegacyImportListAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/historicalInstance`, data, headers);
  getContractsByInstanceIdAPI = (data) =>
    RestfulProvider.post(
      `${subUrllocal}/historicalInstanceData`,
      data,
      headers
    );
  getDistributedContractDetailsAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/distributeContracts`, data, headers);
  getBufferDataFromUrlAPI = (data) =>
    RestfulProvider.downloadMethod(`${localurl}/content/getpdf`, data, headers);
  extractMetaDataWithAIAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}//fillContract`, data, headers);
  editHistoricalContractsAPI = (data) =>
    RestfulProvider.formDatapost(`${subUrllocal}/submit`, data, headers);
  SendfilesandfolderAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/sendfilesandfolders`, data, headers);
  getTokenforGoogledriveAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/getToken`, data, headers);
  createBulkLegacyContractAPI = (data) =>
    RestfulProvider.formDatapost(`${subUrllocal}/bulkpdfupload`, data, headers);
  getDuplicatesContractListsAPI = (data) =>
    RestfulProvider.post(
      `${subUrllocal}/duplicateContractsList`,
      data,
      headers
    );
  deleteDuplicatesContractsAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/duplicatedelete`, data, headers);
  getLegalAssociatesAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/getLegalAssociates`, data, headers);
  getBulkAssignedDataAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/getAssignmentData`, data, headers);
  getBulkAssignTasktoLegalAssociatesAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/bulkAssignContracts`, data, headers);
  getBulkReAssignTasktoLegalAssociatesAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/bulkReassignContracts`, data, headers);
  getAssignTasktoLegalAssociatesAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/assignContract`, data, headers);
  unassignContractToLegalAssociateAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/reassignContract`, data, headers);
  getExcelforBulkHistoricalAPI = (data) =>
    RestfulProvider.downloadMethod(`${subUrllocal}/exportExcel`, data, headers);
  updateMetaDataThrouCSVAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/bulkUpload`, data, headers);
  findmissingcontractAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/findmissingcontract`, data, headers);
  getImportDetailsAPI = (data) =>
    RestfulProvider.post(
      `${subUrllocal}/historicalInstanceDetail`,
      data,
      headers
    );
}
// eslint-disable-next-line
export default new legacyServices();
